import React from 'react';
import { ReactComponent as IconIA } from 'assets/images/icone-ia.svg';
import { AlertBox } from './styles';

interface AiSourceAlertBoxProps {
  id: string;
  visible: boolean;
  children: React.ReactNode;
}

const AiSourceAlertBox: React.FC<AiSourceAlertBoxProps> = ({ id, visible, children }) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!visible) return <>{children}</>;

  const messageId = `${id}-message`;

  return (
    <AlertBox id={id} className="mb-3" role="note" aria-describedby={messageId}>
      <IconIA className="ia-badge" aria-hidden="true" />
      {children}
      <small id={messageId} className="d-block font-italic">
        Este CNPJ foi obtido em um banco de dados externo, por favor valide antes de continuar.
      </small>
    </AlertBox>
  );
};

export default AiSourceAlertBox;
